function confirm_edit_item_notice() {
  if ($("#radio-notice-1").prop("checked")) {
    return confirm("メールで通知します。よろしいですか?");
  }
  return true;
}

function dialog_error_hide_and_clean() {
  $(".dialog-errors").hide();
  $("ul.errors").empty();
}
function dialog_error_add_item(msg) {
  $("ul.errors").append($("<li />").html(msg));
}
function dialog_error_show() {
  $(".dialog-errors").show();
  $(".modal").scrollTo(".dialog-errors", "fast");
}
function show_dialog_error(msg) {
  dialog_error_hide_and_clean();
  dialog_error_add_item(msg);
  dialog_error_show();
}

// Setup modal handlers for duplicate link and cleanup
// Note: Modal instance is already created by turbo_stream template
function setupModalHandlers(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  // Handle duplicate link (この記事を元に新規作成など)
  const duplicateLink = modal.querySelector(".duplicate-article-link");
  if (duplicateLink) {
    duplicateLink.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        const url = this.href;
        const currentModal = document.getElementById(modalId);
        const modalInstance = bootstrap.Modal.getInstance(currentModal);

        if (modalInstance) {
          // インスタンスを破棄してクリーンアップ
          modalInstance.dispose();

          // バックドロップを手動で削除
          const backdrops = document.querySelectorAll(".modal-backdrop");
          backdrops.forEach((backdrop) => backdrop.remove());

          // body から modal-open クラスを削除
          document.body.classList.remove("modal-open");
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";

          // モーダルの内容をクリア
          currentModal.innerHTML = "";

          // 少し待ってから新しいモーダルをロード
          setTimeout(() => {
            fetch(url, {
              method: "GET",
              headers: {
                Accept: "text/vnd.turbo-stream.html",
                "X-Requested-With": "XMLHttpRequest",
              },
            })
              .then((response) => response.text())
              .then((html) => Turbo.renderStreamMessage(html));
          }, 100);
        }
      },
      { once: true }
    );
  }

  // Clean up modal on close
  modal.addEventListener(
    "hidden.bs.modal",
    function () {
      const instance = bootstrap.Modal.getInstance(modal);
      if (instance) {
        instance.dispose();
      }

      modal.innerHTML = "";
    },
    { once: true }
  );
}

// Legacy function name for backward compatibility
function initializeModal(modalId) {
  setupModalHandlers(modalId);
}

// Export functions to make them globally available
window.confirm_edit_item_notice = confirm_edit_item_notice;
window.dialog_error_hide_and_clean = dialog_error_hide_and_clean;
window.dialog_error_add_item = dialog_error_add_item;
window.dialog_error_show = dialog_error_show;
window.show_dialog_error = show_dialog_error;
window.setupModalHandlers = setupModalHandlers;
window.initializeModal = initializeModal;
